/**
 * Settings › HR › Job Roles (piece 34, *Job Role registry*; decision 3181; the
 * HR review's R12). 🔒 Code, name, duties, the workers' compensation class code,
 * the default basis and overtime class and the field-work flag; a role with no
 * class code reads as a gap. A role is deactivated, never deleted.
 */
import type { FlsaClassificationName, PayBasisName } from './hire';

/** The Settings page. */
export const JOB_ROLES_ROUTE = '/settings/hr/job-roles';
/** The registry's list and its add, relative to the API root. */
export const JOB_ROLES_PATH = '/settings/job-roles';

/** One role's edit and its deactivation. */
export function jobRolePath(id: string): string {
  return `/settings/job-roles/${encodeURIComponent(id)}`;
}

export interface JobRoleRow {
  id: string;
  version: number;
  code: string;
  name: string;
  dutyDescription: string;
  workersCompClassCode: string | null;
  defaultBasis: PayBasisName;
  defaultFlsaClassification: FlsaClassificationName;
  isFieldWork: boolean;
  isActive: boolean;
  /** How many positions name the role, so a deactivation is read against its use. */
  positions: number;
}

/** What the window sends. */
export interface JobRoleDraft {
  code: string;
  name: string;
  dutyDescription: string;
  workersCompClassCode: string;
  defaultBasis: PayBasisName;
  defaultFlsaClassification: FlsaClassificationName;
  isFieldWork: boolean;
}

/** 🔒 The duties are required, because an insurance audit is conducted against them (decision 0129). */
export function jobRoleProblems(draft: JobRoleDraft): string[] {
  const problems: string[] = [];
  if (!draft.code.trim()) problems.push('A job role has a code.');
  if (!draft.name.trim()) problems.push('A job role has a name.');
  if (!draft.dutyDescription.trim()) problems.push('A job role is defended with a description of its duties.');
  return problems;
}

/** 🔒 A role with no class code reads as a gap on the list (the HR review's R12). */
export function jobRoleHasGap(row: Pick<JobRoleRow, 'workersCompClassCode'>): boolean {
  return !row.workersCompClassCode?.trim();
}
